export default __webpack_public_path__ + "static/media/promo-table.ab7a214b.png";